import { Directive, HostListener, HostBinding } from "@angular/core";

@Directive({
    selector: '[appDropdown]',
    standalone: false
})

export class DropdownDirective {
    @HostBinding('class.opened') isOpen = false;

    @HostListener('click') 
    onClick() {
        this.isOpen = !this.isOpen;
    }
}